import React from 'react';
import StayPage from './StayPage';

const BookingPage = () => <StayPage mode="booking_date" />;

export default BookingPage;
